import { registerTourPage } from '@/composables/tour/tourRegistry';
import { step, introStep } from '@/composables/tour/stepHelpers';

registerTourPage('admin-grade-system', {
  key: 'admin-grade-system',
  label: 'Grade System',
  getSteps: () => [
    introStep({
      title: 'Grade System',
      content:
        'Define how raw scores are converted into letter grades. Each group (e.g. "Senior Secondary") can have its own grade boundaries, used wherever results are computed.',
    }),
    step({
      target: '#tour-grade-actions',
      title: 'Add Grades',
      content:
        'Use "Quick Setup" to seed common Nigerian/British/US grade scales in seconds, or "Add New Grade" to define a single bracket manually.',
      placement: 'bottom',
    }),
    step({
      target: '#tour-grade-list',
      title: 'Grade Groups',
      content:
        'Each group lists its grades from highest to lowest. Use the action buttons on a row to edit a grade\'s range and remarks, or remove one you no longer need.',
      placement: 'top',
    }),
  ],
});
